import { useSelector, shallowEqual } from 'react-redux';

import { selectSlice as selectConsumption } from 'state/consumption/consumption-slice';
import { selectIsDirectConsumption } from 'state/consumption-entry/consumption-entry-slice';
import type { ConsumptionState } from 'state/consumption/consumption-slice';

type consumptionReturnType = {
  consumption: ConsumptionState;
  isDirectConsumptionInput: boolean;
};

export const useConsumption = (): consumptionReturnType => {
  const consumption = useSelector(selectConsumption, shallowEqual);
  const isDirectConsumptionInput = useSelector(
    selectIsDirectConsumption,
    shallowEqual
  );
  return { consumption, isDirectConsumptionInput };
};
